export default __webpack_public_path__ + "static/media/faceTrainexe.509dbd3f.gif";